import { ThemeConfig } from 'antd';

const COLOR_PRIMARY = '#000032';

const theme: ThemeConfig = {
  token: {
    colorPrimary: COLOR_PRIMARY,
    colorLink: COLOR_PRIMARY,
    fontFamily: 'Figtree',
    fontSize: 14,
  },
  components: {
    Menu: {
      fontSize: 15,
      itemHeight: 40,
      lineHeight: 22,
      fontWeightStrong: 600,
    },
  },
};

export default theme;
